module.exports = __webpack_public_path__ + "static/img/hou1.77ae117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/hou1.png
// module id = ppoA
// module chunks = 0